import * as React from 'react';
import {faAngleRight} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {ProductImage} from '../../ui/ProductImage/ProductImage';
import {pushGaEvent} from '../../../client/ga/ga.functions';
import {SearchResult, SubCat} from '../search.types';
import {URLBuilder} from '../../../server/tools/url-builder/url-builder.class';
import {User} from '../../users/user.class';

interface CategoryResultCardProps {
    buildURL: URLBuilder;
    debugWebcat: boolean;
    resultList: SearchResult;
    subCat: SubCat;
    user: User;
}

export const CategoryResultCard = ({buildURL, debugWebcat, resultList, subCat, user}: CategoryResultCardProps) => (
    <div className="tw-relative tw-flex tw-flex-col tw-bg-white tw-border tw-rounded-sm tw-min-w-0 tw-h-full">
        <a
            className="tw-no-underline hover:tw-no-underline"
            href={buildURL.withWebcat(subCat.categoryPath)}
            onClick={() =>
                pushGaEvent(`ga4_category_click`, {
                    click_action: `navigation`,
                    click_category_1: `category_tile`,
                    click_category_2: `view_all`,
                    click_path: buildURL.withWebcat(subCat.categoryPath),
                    click_type: `category_click`,
                    selection_name: `${resultList.title} | ${subCat.name}`,
                })
            }
        >
            <ProductImage
                altText={subCat.name}
                className="tw-max-w-full tw-h-auto"
                containerClass="tw-items-center tw-justify-center tw-p-3 tw-hidden md:tw-flex tw-border-b"
                size={120}
                src={subCat.imageAssetLargeThumb}
                srcIncludesImgThumbsPath
            />
            <div className="!tw-p-0 md:!tw-p-4 tw-h-full">
                <div className="tw-flex tw-m-0 tw-h-full">
                    <ProductImage
                        altText={subCat.name}
                        className="tw-max-w-full tw-h-auto"
                        containerClass="tw-w-1/3 tw-flex md:tw-hidden tw-border-r tw-p-3 tw-items-center tw-content-center"
                        size={120}
                        src={subCat.imageAssetLargeThumb}
                        srcIncludesImgThumbsPath
                    />
                    <div className="tw-w-2/3 md:tw-w-full tw-p-4 md:tw-p-0">
                        <div className="tw-text-xl tw-font-normal tw-mb-2 tw-p-0">
                            <strong className="!tw-text-black">{subCat.name}</strong>
                            {debugWebcat && `| WID: ${subCat.id}`}
                            {resultList.debug && `| Sort:${subCat.sortOrder} | ID: ${subCat._id}`}
                        </div>
                        {subCat.numItems && (
                            <div
                                className={`tw-mb-3 tw-p-0 tw-text-gray-500 ${
                                    subCat.lookAheadLinks && !resultList.brand ? ' tw-mb-3' : ''
                                } tw-text-sm tw-leading-[1.3] tw-font-normal`}
                            >
                                ({subCat.numItems})
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </a>
        <div
            className="tw-relative"
            style={{zIndex: 899}}
        >
            {subCat.lookAheadLinks &&
                !resultList.brand &&
                !(user.hasCustomCatalogs() && user.hasCurrentPcode) &&
                subCat.lookAheadLinks.map((link, linkKey) => {
                    if (link) {
                        return (
                            <div
                                className="tw-mx-4 tw-my-2"
                                key={linkKey}
                            >
                                <a
                                    className="tw-block"
                                    href={buildURL.withWebcat(link.categoryPath)}
                                    onClick={() =>
                                        pushGaEvent(`ga4_category_click`, {
                                            click_action: `navigation`,
                                            click_category_1: `category_tile`,
                                            click_category_2: `look_ahead`,
                                            click_path: buildURL.withWebcat(link.categoryPath),
                                            click_type: `category_click`,
                                            selection_name: `${resultList.title} | ${subCat.name} | ${link.linkText}`,
                                        })
                                    }
                                >
                                    {link.linkText}
                                </a>
                            </div>
                        );
                    }
                })}
        </div>
        {subCat.lookAheadLinks && !resultList.brand && !(user.hasCustomCatalogs() && user.hasCurrentPcode) && (
            <div className="tw-py-3 tw-relative tw-px-5 tw-w-full tw-border-t md:!tw-border-t-0 tw-text-right md:tw-text-left !tw-bg-white">
                <a
                    className="tw-w-full tw-block after:tw-absolute after:tw-w-full after:tw-top-0 after:tw-right-0 after:tw-bottom-0 after:tw-z-[-1] after:tw-pointer-events-auto after:tw-content-[''] after:tw-bg-white tw-font-bold"
                    href={buildURL.withWebcat(subCat.categoryPath)}
                    onClick={() =>
                        pushGaEvent(`ga4_category_click`, {
                            click_action: `navigation`,
                            click_category_1: `category_tile`,
                            click_category_2: `view_all`,
                            click_path: buildURL.withWebcat(subCat.categoryPath),
                            click_type: `category_click`,
                            selection_name: `${resultList.title} | ${subCat.name}`,
                        })
                    }
                >
                    View All{' '}
                    <FontAwesomeIcon
                        className="tw-ml-2"
                        color="black"
                        icon={faAngleRight}
                    ></FontAwesomeIcon>
                </a>
            </div>
        )}
    </div>
);
